export const isManualTab = (filter: any) => {
    return filter?.hasOwnProperty('usingFilterOrManual') && filter?.usingFilterOrManual === false
}export const isManualTab = (filter: any) => {
    return filter?.hasOwnProperty('usingFilterOrManual') && filter?.usingFilterOrManual === false
}